// Numbers reads so a reply to one a newer read (or a local write) replaced is dropped. Held outside React state,
// as it changes on every read, and kept out of refs so callbacks that read it can be handed to children.
export function createReadSequence() {
  let latest = 0;
  let known = false;
  return {
    next: () => ++latest,
    isLatest: (read: number) => read === latest,
    /** Whether a read has landed since the last reset. */
    isKnown: () => known,
    markKnown: () => { known = true; },
    reset: () => { latest += 1; known = false; },
  };
}
